
export const createPassword = (len) => {
  // 创建随机密码
  const seed = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']
  const lenSeed = seed.length
  let str = ''
  for (let i = 0; i < len; i += 1) {
    const j = Math.floor(Math.random() * lenSeed)
    str += seed[j]
  }
  return str
}

export const noChineseCheck = (strPwd) => {
  // 判断是否为字母或者数字
  const reg = /^[A-Za-z0-9]+$/
  if (reg.test(strPwd)) {
    return true
  }
}

export const waterMarkCheck = (strWater) => {
  // 判断是否包含特殊字符
  const reg = /[\^.*<>%&',;=?$"':#@!~\][{}\\/`|+\-()]/
  return reg.test(strWater)
}

// 天数转换时间戳
export const getTimeDay = (day) => day * 24 * 60 * 60 * 1000

export const leftTimer = (enTime) => {
  // 计算剩余时间
  let timeArr
  if (enTime.indexOf('-') > -1) {
    timeArr = enTime.split('-')
  } else if (enTime.indexOf('/') > -1) {
    timeArr = enTime.split('/')
  } else {
    console.log('剩余时间计算有误')
  }

  const y = timeArr[0]
  const m = timeArr[1] - 1
  const d = timeArr[2]
  const leftTime = new Date(y, m, d, 23, 59, 59) - new Date() // 计算剩余的毫秒数
  const days = parseInt(leftTime / 1000 / 60 / 60 / 24, 10) // 计算剩余的天数
  const hours = parseInt((leftTime / 1000 / 60 / 60) % 24, 10) // 计算剩余的小时
  const minutes = parseInt((leftTime / 1000 / 60) % 60, 10) // 计算剩余的分钟
  return `${days} ${i18n.t('linkShare.day')} ${hours} ${i18n.t('linkShare.hour')} ${minutes} ${i18n.t('linkShare.minute')}`
}

export const formatDate = (dateObj = new Date(), format) => {
  let fmt = format
  let year; let month; let date; let hours; let minutes; let
    seconds

  if (!dateObj) return

  if (Object.prototype.toString.call(dateObj) === '[object Date]') {
    year = dateObj.getFullYear()
    month = dateObj.getMonth() + 1
    date = dateObj.getDate()
    hours = dateObj.getHours()
    minutes = dateObj.getMinutes()
    seconds = dateObj.getSeconds()
  } else {
    const regexp = /([\d]{4})-([\d]{2})-([\d]{2})T([\d]{2}):([\d]{2}):([\d]{2})(?:\+([\d]{2}):([\d]{2}))?/
    const d = regexp.exec(dateObj)
    if (!d) return
    year = d[1]
    month = d[2]
    date = d[3]
    hours = d[4]
    minutes = d[5]
    seconds = d[6]
  }
  const o = {
    'M+': +month, // 月份
    'd+': +date, // 日
    'h+': +hours, // 小时
    'm+': +minutes, // 分
    's+': +seconds, // 秒
    'q+': Math.floor((+month + 3) / 3), // 季度
    // "S": d.getMilliseconds() //毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${year}`).substr(4 - RegExp.$1.length))
  }

  Object.keys(o).forEach((k) => {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(RegExp.$1,
        (RegExp.$1.length === 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)))
    }
  })

  return fmt
}
